import React from 'react'
import { string, array } from 'prop-types'
import { ButtonGroup } from '@/component/Primitive/Events'
import styles from './EventButtonGroup.module.scss'
import cx from 'classnames'

export const EventButtonGroup = ({ align, theme, buttonGroup }) => {
  return (
    <div
      className={cx(
        styles.EventButtonGroup,
        theme === 'dark' && styles.dark,
        align === 'center' && styles.center
      )}
    >
      {!!buttonGroup?.length && <ButtonGroup group={buttonGroup} />}
    </div>
  )
}

EventButtonGroup.propTypes = {
  align: string,
  theme: string,
  buttonGroup: array
}
